import { CheckCircleIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import api from "../api";

const getPeriod = selectedPlan => {
  if (selectedPlan?.type === "annually") return "year";
  else if (selectedPlan?.type === "monthly") return "month";
  return "N/A";
};

export default function ChangePlanModal({
  open,
  onClose,
  onSubmit,
  loading,
  selectedPlan,
}) {
  const [diff, setDiff] = useState(0);

  const period = getPeriod(selectedPlan);

  const calcPlanDiff = async payment_plan_id => {
    try {
      const { data } = await api.get(
        `/api/billing/calc_plan_diff/${payment_plan_id}`
      );
      setDiff(selectedPlan?.cost - data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (open && selectedPlan) {
      calcPlanDiff(selectedPlan.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlan, open]);

  return (
    <Modal
      title="Upgrade Subscription"
      description={
        <div>
          <p>
            By clicking <span className="font-semibold">Upgrade</span>, you will
            subscribe to the{" "}
            <span className="font-semibold">
              {selectedPlan?.name || "N/A"} plan
            </span>{" "}
            for ${selectedPlan?.cost || "N/A"} per {period}.
          </p>

          <p>
            Your credit card will be charged{" "}
            <span className="font-semibold">${diff}</span> immediately for the
            remaining days in your billing cycle.
          </p>
        </div>
      }
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={loading}
      startIcon={
        <CheckCircleIcon aria-hidden="true" className="size-8 text-green-600" />
      }
    />
  );
}
